/**
 * Toggle switch styles
 */
import { Platform } from 'react-native';

import styled from 'styled-components/native';
import { color, ColorProps } from 'styled-system';

import { Colors } from 'theme/colors';

export const SWITCH_WIDTH = 56;
export const KNOB_WIDTH = 25;

const CONTENT_PADDING = { web: '3px', ios: '2.5px', android: '2.5px' };

export const SwitchContainer = styled.View`
  border-width: 1px;
  border-color: ${Colors.steel};
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
  padding-left: 22px;
  border-radius: 20px;
  flex-direction: row;
  flex-shrink: 1;
  align-items: center;
  align-self: center;
  margin-top: 10px;
`;

export const SwitchButton = styled.TouchableOpacity<ColorProps>`
  width: ${SWITCH_WIDTH}px;
  height: 30px;
  border-radius: 15px;
  margin-left: 11px;
  padding-vertical: ${Platform.select(CONTENT_PADDING)};
  padding-horizontal: ${Platform.select(CONTENT_PADDING)};
  position: relative;
  overflow: hidden;
  ${color};
`;

export const Overlay = styled.View`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: ${Colors.alto};
  border-radius: 15px;
`;

export const Knob = styled.View`
  width: ${KNOB_WIDTH}px;
  height: ${KNOB_WIDTH}px;
  border-radius: ${KNOB_WIDTH / 2}px;
  background-color: ${Colors.white};
`;
